import { render, staticRenderFns } from "./dict_management.vue?vue&type=template&id=9168d846&scoped=true&"
import script from "./dict_management.vue?vue&type=script&lang=js&"
export * from "./dict_management.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9168d846",
  null
  
)

export default component.exports